import { browserHistory } from 'react-router';
import configureStore from 'src/store/configureStore';

const store = configureStore(browserHistory);

export default store;
